import { IUpdateSaidaPUseCase } from "../../../presentation/useCases/update/update_saida_produtos_use_case";
import { IEstoqueRepository } from "../../repositories/estoque_repository";

export class UpdateSaidaPUseCase implements IUpdateSaidaPUseCase {
  constructor(private readonly repository: IEstoqueRepository) {}

  async updateSaidaP(IdSaidaProduto: number, Data?: Date | null, IdCentroCusto?: number | null, IdCentroCustoDestino?: number | null, IdProdutoServico?: number | null, NroNotaFiscal?: string | null, Quantidade?: number | null, IdFornecedor?: number | null, IdFuncionario?: number | null, NrNotaFiscal?: string | null, IdSessaoMultipla?: string | null, Delete?: boolean | null, ValorUnitario?: number | null, localAplicacao?: string | null): Promise<void> {
    
    await this.repository.updateSaidaP(IdSaidaProduto, Data, IdCentroCusto, IdCentroCustoDestino, IdProdutoServico, NroNotaFiscal, Quantidade, IdFornecedor, IdFuncionario, NrNotaFiscal, IdSessaoMultipla, Delete, ValorUnitario, localAplicacao
    );
  }
}
